<template>
    <section :id="`element-${settings.id}`" class="elle-registration padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline :settings="{ label: settings?.label, headline: settings?.headline }">
                        <template #additional>
                            <div class="content typography" v-html="props.settings?.body" />
                            <UiBtn :style="'transparent w-border'" :text="$t('postcode.postcode_label')" @btn-click="e => (showWidget = true)" />
                        </template>
                    </UiHeadline>
                </div>
                <div class="r-col">
                    <FormsRegister :locations="settings.locations" :privacy-policy="settings.privacyPolicy" :success="settings.success" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
const showWidget = useShowPostCodeWidget();
</script>
